document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-vfsp-section]');

    sections.forEach((sectionEl) => {
        const items = Array.from(sectionEl.querySelectorAll('.vfsp-acc-item'));
        const quick = sectionEl.querySelector('[data-vfsp-quick]');
        const quickBtn = quick?.querySelector('.vfsp-footer__quick-trigger');
        const quickPanel = quick?.querySelector('.vfsp-footer__quick-panel');

        const isMobile = () => window.innerWidth <= 768;

        const syncA11yState = () => {
            const mobile = isMobile();

            items.forEach((item) => {
                const btn = item.querySelector('.vfsp-acc-trigger');
                const panel = item.querySelector('.vfsp-acc-panel');
                if (!btn || !panel) return;

                if (mobile) {
                    const isOpen = item.classList.contains('is-open');
                    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                    panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
                } else {
                    item.classList.remove('is-open');
                    btn.setAttribute('aria-expanded', 'true');
                    panel.setAttribute('aria-hidden', 'false');
                }
            });

            if (quick && quickBtn && quickPanel) {
                if (mobile) {
                    const isOpen = quick.classList.contains('is-open');
                    quickBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                    quickPanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
                } else {
                    quick.classList.remove('is-open');
                    quickBtn.setAttribute('aria-expanded', 'true');
                    quickPanel.setAttribute('aria-hidden', 'false');
                }
            }
        };

        items.forEach((item) => {
            const btn = item.querySelector('.vfsp-acc-trigger');
            if (!btn) return;

            btn.addEventListener('click', () => {
                if (!isMobile()) return;
                item.classList.toggle('is-open');
                syncA11yState();
            });
        });

        if (quick && quickBtn) {
            quickBtn.addEventListener('click', () => {
                if (!isMobile()) return;
                quick.classList.toggle('is-open');
                syncA11yState();
            });
        }

        syncA11yState();

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(syncA11yState, 100);
        });

        // Back to Top Logic
        const backToTopBtn = sectionEl.querySelector('.vfsp-back-to-top');
        if (backToTopBtn) {
            window.addEventListener('scroll', () => {
                if (window.scrollY > 300) {
                    backToTopBtn.classList.add('is-visible');
                } else {
                    backToTopBtn.classList.remove('is-visible');
                }
            });

            backToTopBtn.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }
    });
});
